import { format } from 'date-fns'
import { ObsType } from '../../dto/LocalDTO'
import { useEffect, useState } from 'react'
import { INITIAL_ROWS_PER_PAGE } from '../../pages/AdminProducts/ABMProducts/components/Table/TableFooter'
import TableDataPagination from '../../pages/Products/components/TableDataPagination'
import { defaultPaginator, Paginator } from '../../pages/Products/context/productos.vendedor.context'

interface PropsObs {
  observaciones: ObsType[]
}

/* eslint-disable react/prop-types */
const ObservacionesTable: React.FC<PropsObs> = ({ observaciones }) => {
  const [listado, setListado] = useState<ObsType[]>([])
  const [paginator] = useState<Paginator>(defaultPaginator)
  const [page, setPage] = useState<number>(0)
  const [pageSize, setPageSize] = useState<number>(INITIAL_ROWS_PER_PAGE)

  paginator.handleChangePage = (e: any, newPage: number) => {
    setPage(newPage)
    setListado(observaciones.slice(newPage * pageSize, newPage * pageSize + pageSize))
  }

  paginator.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newPageSize = parseInt(event.target.value, 10)
    setPageSize(newPageSize)
    setPage(0)
    setListado(observaciones.slice(0, newPageSize))
  }

  useEffect(() => {
    setPage(0)
    setPageSize(INITIAL_ROWS_PER_PAGE)
    setListado(observaciones.slice(0, INITIAL_ROWS_PER_PAGE))
  }, [observaciones])

  return (
    <table className="table table-striped table-bordered premise-table" style={{ marginLeft: '10px', width: '98%' }}>
      <thead>
        <tr>
          <th>Fecha de Creación</th>
          <th>Nombre de Usuario</th>
          <th>Observaciones</th>
        </tr>
      </thead>
      <tbody>
        {listado?.map((obs: ObsType) => (
          <tr key={obs.idLocalObservaciones}>
            <th style={{ fontWeight: 'normal' }}>
              {obs.fechaCreacion && format(new Date(obs.fechaCreacion), 'dd/MM/yy, HH:ss')}
            </th>
            <th style={{ fontWeight: 'normal' }}>{obs.nombreUsuario}</th>
            <th style={{ fontWeight: 'normal' }}>
              <pre style={{ margin: 0, fontFamily: 'inherit' }}>{obs.observaciones}</pre>
            </th>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <TableDataPagination
          total={observaciones.length}
          page={page || 0}
          paginator={paginator}
          items={observaciones || []}
          rowsPerPage={pageSize || INITIAL_ROWS_PER_PAGE}
          component={'td'}
          label={`Observaciones por página`}
        />
      </tfoot>
    </table>
  )
}

export default ObservacionesTable
